(function() {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function isCollectionPage() {
    return /^\/collections\//.test(window.location.pathname);
  }

  function mappedCollectionUrl(rawHref) {
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return rawHref;
    }
    if (url.origin !== window.location.origin) return rawHref;
    var redirects = {
      '/collections/set-11-winterspell-fu-ben': '/collections/lorcana-set-12-wilds-unknown',
      '/collections/set-12-wilds-unknown': '/collections/lorcana-set-12-wilds-unknown',
      '/collections/dm25-rp4-wang-dao-w-di-4dan-zhong-yuan-love-abyss-fu-ben': '/collections/duel-master-dm25-ex2-deyueking-wdream-2025',
      '/collections/dm25-ex2-deyueking-wdream-2025': '/collections/duel-master-dm25-ex2-deyueking-wdream-2025',
      '/collections/dm25-ex2-wang-dao-vsxie-dao-deyuekinguwdream-2025-fu-ben': '/collections/duel-master-dm25-ex4-episode-4-pandora-wars',
      '/collections/dm25-ex4-episode-4-pandora-wars': '/collections/duel-master-dm25-ex4-episode-4-pandora-wars',
      '/collections/dgm-ad01-digimon-generation-fu-ben': '/collections/riftbound-lol-ogn-origin',
      '/collections/lol-ogn-origin': '/collections/riftbound-lol-ogn-origin',
      '/collections/ocg-copy': '/collections/riftbound-lol-unl-unleashed'
    };
    var target = redirects[url.pathname.toLowerCase()];
    if (!target) return rawHref;
    url.searchParams.delete('view');
    return target + url.search + url.hash;
  }

  function isDefaultCollectionUrl(url) {
    return false;
  }

  function defaultCollectionUrl(rawHref) {
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return rawHref;
    }
    if (url.origin !== window.location.origin || !isDefaultCollectionUrl(url)) return rawHref;
    if (!/^mobile/.test(url.searchParams.get('view') || '')) return rawHref;
    url.searchParams.delete('view');
    return url.pathname + url.search + url.hash;
  }

  function isSingleCardCollectionUrl(url) {
    return url &&
      /^\/collections\//.test(url.pathname) &&
      !/^\/collections\/products-/.test(url.pathname) &&
      url.pathname.indexOf('-products') === -1 &&
      url.pathname.indexOf('fu-ben') === -1;
  }

  function mobileSingleUrl(rawHref) {
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (e) {
      return rawHref;
    }
    if (url.origin !== window.location.origin) return rawHref;
    if (!isSingleCardCollectionUrl(url)) return rawHref;
    url.searchParams.set('view', 'mobile-single');
    return url.pathname + url.search + url.hash;
  }

  function disableMobileFacebookFrame(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('[data-fb-page-wrapper]').forEach(function(wrapper) {
      if (wrapper.dataset.bgtcgMobileFallback === 'true') return;
      wrapper.dataset.bgtcgMobileFallback = 'true';
      wrapper.innerHTML = '<div class="fb-plugin-fallback">Facebook 動態未能載入。<br><a href="https://www.facebook.com/battleground.hk" target="_blank" rel="noopener noreferrer">開啟 Battleground Facebook 專頁</a></div>';
    });
  }

  var currentStock = 'all';
  var currentRarity = 'all';

  function setActiveButton(selector, activeValue, attrName) {
    document.querySelectorAll(selector).forEach(function(button) {
      button.classList.toggle('active', button.getAttribute(attrName) === activeValue);
    });
  }

  function restoreVisibleCards() {
    document.querySelectorAll('#ProductGridContainer .grid__item:not(.rarity-hidden):not(.stock-hidden)').forEach(function(item) {
      item.classList.remove('scroll-trigger--offscreen');
      item.style.removeProperty('opacity');
      item.style.removeProperty('transform');
      item.style.removeProperty('visibility');
    });
  }

  function applyTopFilters() {
    var flatItems = document.querySelectorAll('#ProductGridContainer .bgtcg-mobile-flat-grid .grid__item[data-rarity]');
    if (flatItems.length) {
      flatItems.forEach(function(item) {
        var rarity = item.getAttribute('data-rarity');
        var available = item.getAttribute('data-available');
        var rarityMatch = currentRarity === 'all' || currentRarity === rarity;
        var stockMatch = currentStock === 'all' ||
          (currentStock === 'in' && available === 'true') ||
          (currentStock === 'out' && available === 'false');

        item.classList.toggle('rarity-hidden', !rarityMatch);
        item.classList.toggle('stock-hidden', !stockMatch);
      });
      restoreVisibleCards();
    }
  }

  function handleTopFilterClick(event) {
    if (!isMobile()) return;

    var stockButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-stock]');
    var rarityButton = event.target.closest && event.target.closest('#collectionTopFilter button[data-rarity]');
    var resetButton = event.target.closest && event.target.closest('#collectionTopFilter .filter-reset');
    if (!stockButton && !rarityButton && !resetButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (stockButton && typeof window.filterStock === 'function') {
      window.filterStock(stockButton.getAttribute('data-stock') || 'all', stockButton);
      return;
    }
    if (rarityButton && typeof window.filterRarity === 'function') {
      window.filterRarity(rarityButton.getAttribute('data-rarity') || 'all', rarityButton);
      return;
    }
    if (resetButton && typeof window.resetFilters === 'function') {
      window.resetFilters();
      return;
    }

    if (stockButton) currentStock = stockButton.getAttribute('data-stock') || 'all';
    if (rarityButton) currentRarity = rarityButton.getAttribute('data-rarity') || 'all';
    if (resetButton) {
      currentStock = 'all';
      currentRarity = 'all';
    }

    setActiveButton('#collectionTopFilter button[data-stock]', currentStock, 'data-stock');
    setActiveButton('#collectionTopFilter button[data-rarity]', currentRarity, 'data-rarity');
    applyTopFilters();
  }

  function applyMobileSafeguards(root) {
    disableMobileFacebookFrame(root);
    if (!isMobile()) return;
    root = root || document;
    root.querySelectorAll('a[href*="/collections/"]').forEach(function(link) {
      var nextHref = mappedCollectionUrl(link.getAttribute('href'));
      if (!nextHref || nextHref === link.getAttribute('href')) {
        nextHref = defaultCollectionUrl(link.getAttribute('href'));
      }
      if (!nextHref || nextHref === link.getAttribute('href')) {
        nextHref = mobileSingleUrl(link.getAttribute('href'));
      }
      if (nextHref && nextHref !== link.getAttribute('href')) {
        link.setAttribute('href', nextHref);
      }
    });
  }

  function normalizeCurrentCollectionView() {
    var url = new URL(window.location.href);
    var mappedUrl = mappedCollectionUrl(url.href);
    if (mappedUrl && mappedUrl !== url.pathname + url.search + url.hash && mappedUrl !== url.href) {
      window.location.replace(mappedUrl);
      return;
    }
    if (!isMobile()) return;
    if (isDefaultCollectionUrl(url) && /^mobile/.test(url.searchParams.get('view') || '')) {
      url.searchParams.delete('view');
      window.location.replace(url.pathname + url.search + url.hash);
      return;
    }
    if (!isSingleCardCollectionUrl(url)) return;
    if (url.searchParams.get('view') === 'mobile-single') return;
    url.searchParams.set('view', 'mobile-single');
    window.location.replace(url.pathname + url.search + url.hash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      normalizeCurrentCollectionView();
      applyMobileSafeguards();
    });
  } else {
    normalizeCurrentCollectionView();
    applyMobileSafeguards();
  }

  document.addEventListener('click', handleTopFilterClick, true);

  document.addEventListener('click', function(event) {
    if (!isMobile()) return;
    var link = event.target.closest && event.target.closest('a[href*="/collections/"]');
    if (!link) return;
    var nextHref = mappedCollectionUrl(link.getAttribute('href'));
    if (!nextHref || nextHref === link.getAttribute('href')) {
      nextHref = defaultCollectionUrl(link.getAttribute('href'));
    }
    if (!nextHref || nextHref === link.getAttribute('href')) {
      nextHref = mobileSingleUrl(link.getAttribute('href'));
    }
    if (!nextHref || nextHref === link.getAttribute('href')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = nextHref;
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) applyMobileSafeguards(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.__bgtcgMobileSafeEntry = {
    collectionPage: isCollectionPage(),
    redirectsDisabled: true
  };
})();
